import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';
import {
  Accordion,
  AccordionSummary,
  LinearProgress,
  linearProgressClasses,
  Stack
} from '@mui/material';

export const MainContainer = styled('div')`
  grid-column: 2;
  color: white;
  font: 10pt arial, sans-serif;
  text-align: left;
`;

export const UselessTopBar = styled('div')`
  height: 40px;
  /* width: 800px; */
  margin-bottom: 15px;
  border-radius: 0 0 10px 10px;
  background-color: #333;
  background-image: -moz-linear-gradient(top, #555, #333);
  background-image: -o-linear-gradient(top, #555, #333);
  box-shadow: 0 2px 0 #000;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 800px;
  }
`;

const RoundedCardStyle = css`
  background-image: -moz-linear-gradient(top, #334259, #1d2633);
  -moz-box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.7);
  -webkit-box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.7);
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.7);
  text-align: center;
  margin: 0 0 15px;
  border-radius: 10px;
  position: relative;
`;

export const NowPlayingContainer = styled('div')`
  ${RoundedCardStyle}
  padding: 20px 0;
  background-color: #bdd6a5;
  color: #067057;
`;

export const RedCardContainer = styled('div')`
  ${RoundedCardStyle}
  background-image: none;
  background-color: #ee3b24;
  color: #ffffff;
  padding: 10px 15px;
`;

export const QuoteBox = styled('div')`
  ${RoundedCardStyle}
  font-weight: bold;
  background-color: #bdd6a5;
  padding: 5px;
  margin: 0 0 15px;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(255, 255, 255, 0.1)),
    to(rgba(0, 0, 0, 0.1))
  );
  color: #067057;
`;

export const Footer = styled('div')`
  position: relative;
  bottom: 0;
  font-size: 0.9em;
  height: 25px;
  color: white;
  padding: 10px;
  border: 1px solid #292929;
  border-radius: 16px 16px 0 0;
  background-color: #333;
  background-image: -moz-linear-gradient(top, #555, #333);
  background-image: -o-linear-gradient(top, #555, #333);
  background-image: -webkit-gradient(linear, left top, left bottom, from(#555), to(#333));
  box-shadow: 0 2px 0 #000;
`;

export const CuteH1 = styled('h1')<{ paddingLeft?: string }>`
  position: relative;
  margin: 0;
  text-align: left;
  font-weight: normal;
  background-image: -moz-linear-gradient(top, #334259, #1d2633);
  background-image: -o-linear-gradient(top, #334259, #1d2633);
  background-image: -webkit-gradient(linear, left top, left bottom, from(#334259), to(#1d2633));
  border-radius: 16px;
  padding: 5px 5px 5px 50px;
  padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '')};
  font-size: 18px;
  background-color: #bdd6a5;
  color: #067057;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(255, 255, 255, 0.1)),
    to(rgba(0, 0, 0, 0.1))
  );
`;

export const PopoutIcon = styled('img')`
  position: absolute;
  top: -17px;
  left: 0px;
  -moz-transform: rotate(-5deg);
  -webkit-transform: rotate(-5deg);
  -o-transform: rotate(-5deg);
  transform: rotate(-5deg);
`;

export const BabySpanInfo = styled('span')`
  background-color: #bdd6a5;
  color: #067057;
  background-image: none;
  font-weight: bold;
  padding: 0px 3px;
  font-size: 10px;
  position: relative;
  top: -3px;
  border-radius: 3px;
  -moz-box-shadow: 0 0 1px #000;
  -webkit-box-shadow: 0 0 1px #000;
  box-shadow: 0 0 1px #000;
`;

export const UnfinishedProgressBar = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 5,
  [`& .${linearProgressClasses.dashed}`]: {
    backgroundImage: 'none',
    animation: 'none'
  },
  [`&.${linearProgressClasses.colorPrimary}`]: {
    height: '14px',
    width: '350px',
    border: '1px solid #333',
    margin: '0 3px',
    borderRadius: '4px',
    background: 'rgba(255, 255, 255, 0.5)',
    backgroundImage: 'linear-gradient(to top, #660000, #330000)',
    backgroundColor: '#430000'
  },
  [`& .MuiLinearProgress-bar`]: {
    borderRight: '0.5px solid #333',
    backgroundImage: 'linear-gradient(to bottom, #b0c141, #657026)',
    borderRadius: '3px 0 0 3px'
  },
  [`& .MuiLinearProgress-bar2Buffer`]: {
    height: '14px',
    width: '350px',
    borderRight: '1px solid #333',
    margin: '0 3px',
    borderRadius: '4px',
    backgroundImage: 'linear-gradient(to bottom, #C77, #990000)',
    backgroundColor: '#430000'
  }
}));

export const BeatenProgressBar = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    height: '14px',
    width: '350px',
    border: '1px solid #333',
    margin: '0 3px',
    borderRadius: '4px',
    background: 'rgba(255, 255, 255, 0.5)',
    backgroundColor: '#414248',
    backgroundImage: 'linear-gradient(to top, #56575e, #37383d)'
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#BDBDBD',
    backgroundImage: 'linear-gradient(to bottom, #EEE, #9B9B9B)'
  }
}));

export const CompletedProgressBar = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    height: '14px',
    width: '350px',
    border: '1px solid #333',
    margin: '0 3px',
    borderRadius: '4px',
    background: 'rgba(255, 255, 255, 0.5)',
    backgroundColor: '#483b22',
    backgroundImage: 'linear-gradient(to bottom, #604f2e, #3c321d)'
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#FFCC66',
    backgroundImage: 'linear-gradient(to bottom, #FDB, #CCAA44)'
  }
}));

export const LibraryGreyCTA = styled('div')<{ roundedAbove?: boolean; roundedBelow?: boolean }>`
  color: white;
  padding: 0px;
  display: block;
  border: 1px solid black;
  text-align: center;
  font-weight: bold;
  width: 100%;
  margin: 2px 10px 2px 0;
  background-color: #777;
  background-image: -moz-linear-gradient(top, #999, #666);
  background-image: -o-linear-gradient(top, #999, #666);
  background-image: -webkit-gradient(linear, left top, left bottom, from(#999), to(#666));
  text-shadow: 0 0 3px black;
  border-radius: ${({ roundedAbove, roundedBelow }) =>
    `${roundedAbove ? '19px 19px' : '0 0'} ${roundedBelow ? '19px 19px' : '0 0'}`};
`;

export const SingleGameCardContainer = styled('div')`
  padding: 0.5rem 0;
  width: 100%;
`;

export const SingleGameCardAccordion = styled(Accordion)`
  &.MuiAccordion-root {
    background-color: inherit;
    box-shadow: initial;
    position: initial;
    padding: 0;
    width: 100%;
    button: {
      background-color: blue;
    }
  }
`;

export const SingleGameCardAccordionSummary = styled(AccordionSummary)`
  h1 {
    position: relative;
    width: 100%;
    margin: 0;
    text-align: left;
    font-weight: normal;
    background-image: -moz-linear-gradient(top, #334259, #1d2633);
    background-image: -o-linear-gradient(top, #334259, #1d2633);
    background-image: -webkit-gradient(linear, left top, left bottom, from(#334259), to(#1d2633));
    border-radius: 16px;
    padding: 5px 5px 5px 0px;
    padding-left: 2.25rem;
    font-size: 18px;
    background-color: #bdd6a5;
    color: #067057;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(255, 255, 255, 0.1)),
      to(rgba(0, 0, 0, 0.1))
    );
  }
`;

export const NowPlayingStackWrapper = styled(Stack)`
  margin: 0 10px;
  padding: 2px 0;
  border-top: 1px solid black;
  text-align: left;
  border-color: rgba(6, 112, 87, 0.25);
`;
